<template>
    <div class="ix-formbuilder-component-summary-content">
        <div class="formbuilder-component boxed" v-if="displayMode == 'readable' || displayMode == 'fillable'">
            <div style="display:flex" class="formbuilder-component-content">
                <div class="formbuilder-component-left">
                    <p class="formbuilder-component-label" v-bind:class="{'required' : currentField.required}">{{ currentField.label }}</p>
                    <p class="formbuilder-component-help" v-if="currentField.helper">{{ currentField.helper }}</p>
                </div>

                <div class="formbuilder-component-right" v-if="displayMode == 'readable'">
                    <span class="formbuilder-indications">Plusieurs choix possibles</span>
                    <div class="formbuilder-option" v-for="(option,index) in currentField.options" :key="index">
                            <span class="formbuilder-checkbox round">
                                <span v-if="currentField.value.includes(option.value)" class="tick">&#10004;</span>
                        </span> 
                        {{ option.value }}
                    </div>
                </div>


                <div class="formbuilder-component-right" v-if="displayMode == 'fillable'" style="width: 100% !important">
                    <div class="form-check" v-for="(item,i) in currentField.options" :key="i">
                        <input class="form-check-input" type="checkbox" :id="'checkbox-'+i+'-'+index" v-model="currentField.value" :value="item.value">
                        <label class="form-check-label" :for="'checkbox-'+i+'-'+index">{{ item.value }}</label>
                    </div>
                </div>

                <div class="clearfix"></div>
            </div>
        </div>

        <div v-if="displayMode == 'summary'" class="ix-formbuilder-component-summary-info">
            <div class="ix-formbuilder-component-summary-handle">
                <span class="ix-drag-icon handle-line"></span>
            </div>
            <div class="ix-formbuilder-component-summary-icon" data-toggle="tooltip" data-placement="top" title="Choix multiple">
                <div class="ix-formbuilder-icon">
                    <i class="far fa-check-square"></i>
                </div>
            </div>
            <div class="ix-formbuilder-component-summary-content">
                <span class="ix-formbuilder-component-summary-label" v-bind:class="{'required': currentField.required}">{{ currentField.label }}</span>
                <span class="ix-formbuilder-component-summary-help" v-if="currentField.helper">{{ currentField.helper }}</span>
                <ul class="ix-formbuilder-component-summary-options">
                    <li>{{ currentField.options.length }} option{{ currentField.options.length > 1 ? 's' : '' }}</li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "CheckboxComponent",
        props: ['currentField', 'showIcon', 'displayMode', 'index'],
        data() {
            return {
                checkList: [],
                mode : this.displayMode,
            }
        },
        mounted() {
            this.currentField.value = Array.isArray(this.currentField.value) ? this.currentField.value : this.checkList
            if(this.displayMode == "readable"){
                this.currentField.value = this.currentField.value.length ? this.currentField.value : 'Non renseigné'
            }
        }
    }
</script>
